var map = {
	"./tela-preta-preta-site (103).webp": 2278,
	"./tela-preta-preta-site (120).webp": 549,
	"./tela-preta-preta-site (131).webp": 2259,
	"./tela-preta-preta-site (133).webp": 9327,
	"./tela-preta-preta-site (134).webp": 328,
	"./tela-preta-preta-site (135).webp": 2094,
	"./tela-preta-preta-site (139).webp": 4541,
	"./tela-preta-preta-site (140).webp": 193,
	"./tela-preta-preta-site (28).webp": 5535,
	"./tela-preta-preta-site (73).webp": 8921,
	"./tela-preta-preta-site (81).webp": 7847,
	"./tela-preta-preta-site (84).webp": 3311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1631;